
import { VListItemIcon } from "vuetify/lib";

export default VListItemIcon.extend({});
